import { Box, Typography } from '@mui/material'
import { RouteProps } from '../../routes/AppRouter'
import styles from './CookiesPolicy.module.css'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HeaderPolicy } from '../../components/header-policy/HeaderPolicy'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { LoggedUser } from '../../modules/users/models/LoggedUser'
import { getUserContainer } from '../../container/user-module'
import { ILoggedUserService } from '../../modules/users/services/LoggedUserService'
import { LOGGED_USER_SERVICE_KEY } from '../../modules/users'
import { PageLayout } from '../layout/PageLayout'

const loggedUserService = getUserContainer().get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)

export function CookiesPolicy(props: RouteProps) {
  const loggedUser = loggedUserService.get()
  const title = props.title || ''
  const [user, setUser] = useState<LoggedUser | undefined>(loggedUser)
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)
  const { t } = useTranslation()

  useEffect(() => {
    const subscription = loggedUserService.getObservable().subscribe((lu) => {
      setUser(lu)
    })
    return () => subscription.unsubscribe()
  }, [])

  return (
    <>
      {user ? (
        <PageLayout scrollable withCard={true}>
          <Box className={styles.containterLogin}>
            <Box display="flex" justifyContent="center">
              <Box className={styles.contentLogin}>
                <h4 className={styles.titleParrafLogin}>{t('applicableRegulationsTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('applicableRegulationsParraf')}
                </Typography>

                <h4 className={styles.titleParrafLogin}>{t('typesOfCookiesTitle')}</h4>
                <Typography className={styles.parraphLogin}>{t('typesOfCookiesParraf')}</Typography>

                <h4 className={styles.titleParrafLogin}>{t('informationPrincipleTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('informationPrincipleParraf')}
                </Typography>

                <h4 className={styles.titleParrafLogin}>{t('principleOfConsentTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('principleOfConsentParraf')}
                </Typography>

                <h4 className={styles.titleParrafLogin}>{t('optionalNatureTitle')}</h4>
                <Typography className={styles.parraphLogin}>{t('optionalNatureParraf')}</Typography>

                <h4 className={styles.titleParrafLogin}>{t('cookiesDeactivationTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('cookiesDeactivationParraf')}
                </Typography>
              </Box>
            </Box>
          </Box>
        </PageLayout>
      ) : (
        <Box className={styles.containter}>
          <Box display="flex" justifyContent="center">
            <HeaderPolicy title={t('cookiesPolicy')} />
            <Box className={styles.content}>
              <h1 className={styles.titleHeader}>{t('cookiesPolicy')}</h1>

              <h4 className={styles.titleParraf}>{t('applicableRegulationsTitle')}</h4>
              <Typography className={styles.parraph}>{t('applicableRegulationsParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('typesOfCookiesTitle')}</h4>
              <Typography className={styles.parraph}>{t('typesOfCookiesParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('informationPrincipleTitle')}</h4>
              <Typography className={styles.parraph}>{t('informationPrincipleParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('principleOfConsentTitle')}</h4>
              <Typography className={styles.parraph}>{t('principleOfConsentParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('optionalNatureTitle')}</h4>
              <Typography className={styles.parraph}>{t('optionalNatureParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('cookiesDeactivationTitle')}</h4>
              <Typography className={styles.parraph}>{t('cookiesDeactivationParraf')}</Typography>
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}
